"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateListYears = void 0;
const datePart_1 = require("./datePart");
/**
 * Zwraca tablicę zawierającą listę lat pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 */
function dateListYears(startDate, endDate) {
    let y1 = (0, datePart_1.datePart)(startDate, 'y');
    const y2 = (0, datePart_1.datePart)(endDate, 'y');
    const result = [];
    while (y1 <= y2) {
        result.push(y1);
        y1++;
    }
    return result;
}
exports.dateListYears = dateListYears;
//# sourceMappingURL=dateListYears.js.map